export default "__VITE_ASSET__C0nEBqg3__"